/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portal_X13_Continue_MicrosoftInputs */

const en_portal_x13_continue_microsoft = /** @type {(inputs: Portal_X13_Continue_MicrosoftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Continue with Microsoft`)
};

/** @type {(inputs: Portal_X13_Continue_MicrosoftInputs) => LocalizedString} */
const ar_portal_x13_continue_microsoft = en_portal_x13_continue_microsoft;

/** @type {(inputs: Portal_X13_Continue_MicrosoftInputs) => LocalizedString} */
const he_portal_x13_continue_microsoft = en_portal_x13_continue_microsoft;

/** @type {(inputs: Portal_X13_Continue_MicrosoftInputs) => LocalizedString} */
const ur_portal_x13_continue_microsoft = en_portal_x13_continue_microsoft;

/** @type {(inputs: Portal_X13_Continue_MicrosoftInputs) => LocalizedString} */
const es_portal_x13_continue_microsoft = en_portal_x13_continue_microsoft;

/** @type {(inputs: Portal_X13_Continue_MicrosoftInputs) => LocalizedString} */
const fr_portal_x13_continue_microsoft = en_portal_x13_continue_microsoft;

/** @type {(inputs: Portal_X13_Continue_MicrosoftInputs) => LocalizedString} */
const de_portal_x13_continue_microsoft = en_portal_x13_continue_microsoft;

/** @type {(inputs: Portal_X13_Continue_MicrosoftInputs) => LocalizedString} */
const pt_portal_x13_continue_microsoft = en_portal_x13_continue_microsoft;

/** @type {(inputs: Portal_X13_Continue_MicrosoftInputs) => LocalizedString} */
const hi_portal_x13_continue_microsoft = en_portal_x13_continue_microsoft;

/** @type {(inputs: Portal_X13_Continue_MicrosoftInputs) => LocalizedString} */
const bn_portal_x13_continue_microsoft = en_portal_x13_continue_microsoft;

/**
* | output |
* | --- |
* | "Continue with Microsoft" |
*
* @param {Portal_X13_Continue_MicrosoftInputs} inputs
* @param {{ locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }} options
* @returns {LocalizedString}
*/
export const portal_x13_continue_microsoft = /** @type {((inputs?: Portal_X13_Continue_MicrosoftInputs, options?: { locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portal_X13_Continue_MicrosoftInputs, { locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_portal_x13_continue_microsoft(inputs)
	if (locale === "he") return he_portal_x13_continue_microsoft(inputs)
	if (locale === "ur") return ur_portal_x13_continue_microsoft(inputs)
	if (locale === "es") return es_portal_x13_continue_microsoft(inputs)
	if (locale === "fr") return fr_portal_x13_continue_microsoft(inputs)
	if (locale === "de") return de_portal_x13_continue_microsoft(inputs)
	if (locale === "pt") return pt_portal_x13_continue_microsoft(inputs)
	if (locale === "hi") return hi_portal_x13_continue_microsoft(inputs)
	if (locale === "bn") return bn_portal_x13_continue_microsoft(inputs)
	return /** @type {LocalizedString} */ ("Continue with Microsoft")
});